export default __webpack_public_path__ + "static/media/goodSmiley.ec8c6fcc.svg";